export const API_URL = window._env_.APP_API;
export const DEFAULT_REDIRECT_URL = window._env_.APP_DEFAULT_REDIRECT_URL;
export const BASENAME = window._env_.APP_BASENAME;
export const IS_TEST = process.env.NODE_ENV === "test";
export const DOMAIN = window._env_.APP_DOMAIN;
export const API_COMMONLOGIN_URL = window._env_.APP_COMMONLOGIN_URL;

export const API_REDIRECT = `${API_URL}/login/step3`;
export const API_VERIFY = `${API_URL}/login/step2`;
export const API_LOG_IN = `${API_URL}/login/step1`;
export const API_LOGIN_SET_PASSWORD = `${API_URL}/login/setpassword`;
export const API_RESEND_EMAIL = `${API_URL}/login/resend-mfa`;
/** WF-9: current tenant MFA policy (`msp_auth_config.mfa_method`). */
export const API_MFA_GET = `${API_URL}/mfa`;
export const API_MFA_SETUP_TOTP = `${API_URL}/mfa/setup/totp`;
export const API_MFA_SETUP_SMS = `${API_URL}/mfa/setup/sms`;
export const API_MFA_SETUP_SMS_RESEND = `${API_URL}/mfa/setup/sms/resend`;
export const API_MFA_ENROLL = `${API_URL}/mfa/enroll`;
export const API_ACTIVATE = `${API_URL}/user/activation`;
export const API_RESET_PASSWORD = `${API_URL}/resetpwd/:token`;
/** WF-8C: POST body `{ email }` — see final-auth-parity-lld.md §3.4 */
export const API_FORGOT_PASSWORD = `${API_URL}/password/forgot`;
/** WF-8C confirm: POST `{ token, newPassword, confirmPassword }` — see final-auth-parity-lld.md §3.4 */
export const API_FORGOT_PASSWORD_CONFIRM = `${API_URL}/password/forgot/confirm`;
export const API_GET_AUTH_TYPE = `${API_URL}/users/authinfo`;
export const API_LOGIN_USING_SAML = `${API_COMMONLOGIN_URL}/login`;
export const API_STASHED_RESPONSE = `${API_URL}/token`;

export const ROUTE_AUTH = "/auth/*";
export const ROUTE_FORGOT_PASSWORD_CONFIRM = "/auth/password/forgot/confirm";
export const ROUTE_PASSWORD_ERROR = "/password-error";
export const ROUTE_AUTH_ERROR = "/auth-failed";
export const ROUTE_AUTH_SAML_ERROR = "/auth-saml-error";
export const GENERIC_ERROR_MESSAGE = "Unexpected error occured";
